import styled from 'styled-components'

interface IPromoProps {
  isPromo?: boolean
  isDarkMode?: boolean
}

export const Container = styled.div`
  background: ${({ theme }) => `rgb(${theme.background.modal})`};
  border-radius: 16px;
  width: 80%;
  height: 80%;
  min-width: 10px;
  border: solid 0.1px ${({ theme }) => `rgb(${theme.component.accent})`};
  padding: 1rem;
  hr {
    display: none;
    opacity: 0.3;
  }

  @media only screen and (min-width: 700px) {
    height: 40rem;
  }

  @media only screen and (min-width: 1090px) {
    width: 700px;
    height: 500px;
    border-radius: 16px;
    hr {
      display: flex;
      width: 100%;
    }
  }
`

export const Wrapper = styled.div`
  border-radius: 16px;

  h1 {
    margin: 0;
    font-size: 24px;
    font-weight: bolder;
  }
  h2 {
    margin: 12px 0 0 0;
    font-weight: 400;
  }
`

export const WrapperContainer = styled.div`
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 0px;
  left: 0px;
  background: rgba(0, 0, 0, 0.5);
  z-index: 2000;
  display: flex;
  justify-content: center;
  align-items: center;
  h2 {
    font-size: 14px;
    margin: 0;
    margin-top: 1.5rem;
  }
  @media only screen and (min-width: 1100px) {
    h2 {
      margin-bottom: 0.5rem;
    }
  }
  @media only screen and (min-width: 1400px) {
    h2 {
      margin-bottom: -3%;
    }
  }
`

export const CloseButton = styled.button`
  border: none;
  background-color: transparent;
  color: ${({ theme }) => `rgb(${theme.grayscale[100]})`};
  font-size: 19px;
`

export const MostRecommended = styled.div`
  background: #076998;
  border-radius: 46px;
  color: white;
  z-index: 20;
  margin-top: -15%;
  padding: 0.3rem;
  display: flex;
  align-self: center;
  font-weight: 700;
`

export const Card = styled.div<IPromoProps>`
  background: ${(props) => (props.isDarkMode ? '#4a4a4a' : '#ffffff')};
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;
  padding: 1rem;
  border-radius: 1rem;
  margin: 0.5rem;
  box-shadow: ${({ theme }) => `0 0px 0.6em rgb(${theme.grayscale[400]})`};
  transition: box-shadow 0.5s;
  width: 16rem;
  height: 80%;
  border: ${(props) => (props.isPromo === true ? '3px solid #FF6600' : 'none')};
  &:hover {
    box-shadow: ${({ theme }) => `0 0px 0.6em rgb(${theme.grayscale[100]})`};
    //box-shadow: rgb(0 0 0 / 36%);
  }

  @media only screen and (min-width: 1025px) {
    margin: 0.8rem;
  }

  @media only screen and (max-width: 400px) {
    margin-top: 1rem;
    margin-bottom: 2rem;
    width: 16rem;
    height: 10rem;
  }
`

export const CardTitle = styled.h2`
  margin-top: 0.8rem;
  margin-bottom: 0.8rem;
  font-size: 1rem;
  line-height: 1.4rem;
  font-weight: 700;
  color: ${({ theme }) => `rgb(${theme.grayscale[100]})`};
  height: 7rem;
`

export const ImageHeader = styled.div`
  display: flex;
  justify-content: end;
  align-items: center;
  width: 100%;
  height: 6.25rem;

  span {
    display: flex;
    justify-content: center;
    font-size: 0.625rem;
    line-height: 0.75rem;
    color: #fff;
    width: 6.301rem;
    height: 1.385rem;
    background-color: transparent;
    border-radius: 4px;
    border-bottom: 1.385rem solid #ff6600;
    border-left: 0.938rem solid transparent;
    border-right: 1.875rem solid transparent;
  }
  p {
    margin-bottom: 0.313rem !important;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .discount {
    font-weight: 600;
    font-size: 0.75rem;
    margin-top: -5.313rem !important;
    margin-left: -2.063rem !important;
    transform: rotate(-38deg);
  }

  img {
    max-width: 6rem;
    max-height: 6rem;
    object-fit: cover;
  }

  @media only screen and (max-width: 400px) {
    img {
      max-width: 3rem;
      max-height: 3rem;
      object-fit: cover;
    }

    .discount {
      font-weight: 600;
      font-size: 0.75rem;
      margin-top: -2.263rem !important;
      margin-left: -2.063rem !important;
      transform: rotate(-38deg);
    }
  }
`

export const InfoCourseWrapper = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  height: 2.5rem;
  align-items: flex-start;
  padding: 0px 0px 8px;
  gap: 10px;
  font-size: 0.9rem;
  justify-content: space-evenly;

  span {
    display: flex;
    align-items: center;
  }

  .qtd {
    margin-left: 0.5rem;
  }
`

export const CardWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 1rem;
  margin-top: 2rem;

  @media only screen and (max-width: 400px) {
    display: block;
  }
`

export const SubscriptionOffer = styled.div`
  h2 {
    width: 80%;
    margin: 0 auto;
    margin-top: 3rem;
    margin-bottom: 1rem;
  }

  .offer-container {
    text-align: center;
    padding: 2rem;

    a {
      color: #0c291b;
      background-color: #00ea84;
      text-align: center;
      text-transform: uppercase;
      border: 1px solid #e0e0e0;
      border-radius: 10px;
      padding: 0.75rem 1.5rem;
      font-weight: 700;
      transition: all 0.2s;
      border-color: rgba(29, 83, 57, 0.24);
    }
  }
`
